import { useTranslation } from 'react-i18next';

export default function PenghuSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Penghu%20Taiwan%20island%20aerial%20view%20turquoise%20ocean%20coral%20reefs%20white%20sand%20beaches%20blue%20sky%20dramatic%20coastline%20natural%20beauty%20drone%20photography%20vivid%20colors%20serene%20landscape%20tropical%20island%20atmosphere%20editorial%20style&width=800&height=600&seq=penghu-img-001&orientation=landscape"
                alt="Penghu Island"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-800/30 to-transparent" />
              {/* Overlay text on image */}
              <div className="absolute bottom-6 left-6 right-6">
                <span className="text-xs text-background-50/80 tracking-widest uppercase mb-2 block">
                  {t('penghu.label')}
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
                  {t('penghu.title')}
                </h2>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="w-full lg:w-1/2">
            <span className="text-xs md:text-sm text-accent-500 font-medium tracking-widest uppercase mb-4 block lg:hidden">
              {t('penghu.label')}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#0A2D5E] leading-tight mb-4 lg:hidden">
              {t('penghu.title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {t('penghu.text')}
            </p>

            {/* Decorative element */}
            <div className="mt-8 flex items-center gap-3">
              <div className="w-16 h-px bg-secondary-400" />
              <div className="w-3 h-3 rotate-45 border border-secondary-400" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}